import { render, staticRenderFns } from "./CampaignInfo.vue?vue&type=template&id=3557911a&scoped=true&"
import script from "./CampaignInfo.vue?vue&type=script&lang=js&"
export * from "./CampaignInfo.vue?vue&type=script&lang=js&"
import style0 from "./CampaignInfo.vue?vue&type=style&index=0&id=3557911a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3557911a",
  null
  
)

export default component.exports